/* skeleton-menu-item-next.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VoWWg%7Bheight%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5E1Y8M%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCP1Y8M%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQm1Y8M%7Bpadding-block-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtko1Y8M%7Bpadding-block-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VBntr%7Bheight%3A1lh%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VUF4f%7Bheight%3A40px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5EFQfX%7Bpadding-inline-start%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCPFQfX%7Bpadding-inline-end%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQmFQfX%7Bpadding-block-start%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtkoFQfX%7Bpadding-block-end%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
import { Flex } from '@atlaskit/primitives/compiled/flex';
import Skeleton from '@atlaskit/skeleton';
const containerStyles = {
  root: "_0jFU0VoWWg _0LQT5E1Y8M _03SyCP1Y8M _46hvQm1Y8M _0xmtko1Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
  content: "_2O5Vij7dHp",
  text: "_0LQT5E1Y8M _03SyCP1Y8M _2O5Vij7dHp _4ouGXIdnbC",
  item: "_2sNsIgmnOE _0jFU0VBntr _3iDTPbQ4SZ _0hPCNLDIqT",
  hasDescription: "_0jFU0VUF4f",
  description: "_2sNsIg7NXe _0jFU0VBntr _3iDTPbQ4SZ _0hPCNLDIqT",
  elemBefore: "_0LQT5EFQfX _03SyCPFQfX _46hvQmFQfX _0xmtkoFQfX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
export interface SkeletonMenuItemNextProps {
  /**
   * Whether to render a description skeleton.
   */
  hasDescription?: boolean;

  /**
   * Whether to render an icon element skeleton.
   */
  hasElemBefore?: boolean;

  /**
   * A unique string that appears as data attribute data-testid in the
   * rendered code, serving as a hook for automated tests.
   */
  testId?: string;
}

/**
 * __Skeleton menu item next__
 *
 * A skeleton menu item is used to display a loading state for a side nav menu item.
 * This component can have an icon element skeleton, and a description skeleton included.
 *
 * This is a variant of `SkeletonMenuItem` that draws its placeholders with
 * `Skeleton` from `@atlaskit/skeleton` rather than plain elements, so they pick up
 * that component's appearance and its interaction-tracing hold. The surrounding
 * layout — heights, paddings and the icon slot — is unchanged, with one exception:
 * the description skeleton spans the full width available to it instead of a fixed
 * 60px.
 */
export const SkeletonMenuItemNext = (props: SkeletonMenuItemNextProps): JSX.Element => {
  const {
    hasDescription = false,
    hasElemBefore = false,
    testId
  } = props;
  return <div data-testid={testId} className={ax([containerStyles.root, hasDescription && containerStyles.hasDescription])}>
			<Flex alignItems="center" xcss={containerStyles.content}>
				{hasElemBefore && <div className={ax([containerStyles.elemBefore])}>
						<Skeleton width="20px" height="20px" borderRadius={"var(--ds-radius-small, 4px)"} isShimmering />
					</div>}

				<Flex xcss={containerStyles.text} gap="space.025" direction="column">
					<div className={ax([containerStyles.item])}>
						<Skeleton width="100%" height="round(1cap, 1px)" borderRadius={"var(--ds-radius-full, 9999px)"} isShimmering />
					</div>

					{hasDescription && <div className={ax([containerStyles.description])}>
							<Skeleton width="100%" height="round(1cap, 1px)" borderRadius={"var(--ds-radius-full, 9999px)"} isShimmering />
						</div>}
				</Flex>
			</Flex>
		</div>;
};